export default __webpack_public_path__ + "static/media/svg-3.0bb234b3.svg";